"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasFooterContainer = exports.CanvasFooter = void 0;

var _palette = require("@artsy/palette");

var _RelatedArticlesCanvas = require("../../RelatedArticles/Canvas/RelatedArticlesCanvas");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CanvasFooter = function CanvasFooter(props) {
  var article = props.article,
      relatedArticles = props.relatedArticles;
  return _react.default.createElement(CanvasFooterContainer, null, relatedArticles && _react.default.createElement(_RelatedArticlesCanvas.RelatedArticlesCanvas, {
    articles: relatedArticles,
    vertical: article.layout !== "news" && article.vertical
  }));
};

exports.CanvasFooter = CanvasFooter;

var CanvasFooterContainer = _styledComponents.default.div.withConfig({
  displayName: "CanvasFooter__CanvasFooterContainer",
  componentId: "sc-1tuekop-0"
})(["border-top:1px solid ", ";"], (0, _palette.color)("black10"));

exports.CanvasFooterContainer = CanvasFooterContainer;
//# sourceMappingURL=CanvasFooter.js.map